import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
import "vant/lib/index.css";
import "lib-flexible";
import i18n from '@/utils/lang';
import VueAMap from 'vue-amap';
import VueTouch from "vue-touch";
// 权限校验
import './permission'
// 数据校验
import './validateUtil'
// 查看大图
import './previewImage'

import './assets/scss/layout.scss'

import Dialog from 'vant'

Vue.prototype.$scrollTop = () => {
  const element = document.querySelectorAll(".pageContent")[0];
  element?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
Vue.prototype.$timeSub = function(time) {
  return time ? time.substring(0, 5) : ''
}

Vue.use(Vant);
Vue.use(VueAMap);
Vue.use(VueTouch, {
  name: 'v-touch'
});
Vue.use(Dialog)
VueTouch.config.swipe = {
  threshold: 10 //手指左右滑动触发事件距离
}

VueAMap.initAMapApiLoader({
  key: '13a95bc92ea449ecce44a1fd9fe91af8',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
